<script>
    export default {
        data() {
            return {
                massupdate: {
                    category: null,
                    blacklist: null,
                    autosort_lock: null,
                    replaceCategories: null,
                    styleAttribute: {
                       select: null,
                       action: null
                    },
                    onlineSince: {
                      clients: null,
                      date: null,
                      action: null,
                    },
                    newSince: {
                      clients: null,
                      date: null,
                      action: null,
                    },
                },
                massupdateLoading: false,
                updateSperreSetzenErlaubt: true,
                updateSperre: null,
                widgetOpen: false,
                allCategories: null,
                replaceCategories: null,
                flatpickr: {
                  start: {
                    minDate: null,
                    maxDate: null
                  },
                  end: {
                    minDate: null
                  },
                  vt: {
                    maxDate: null
                  },
                },
                clientList: {},
            }
        },
        props: {
            route: String,
            total: String,
            selectedRows: Array,
            attributeValues: Array,
            selectedTreeCategory: null,
        },
        watch: {
            widgetOpen(isOpen) {
                if (isOpen && !this.allCategories) {
                    this.load();
                }
            },
        massupdate: {
            deep: true,
            handler(value) {
              if (value.category) {
                this.massupdate.autosort_lock = 1;
                this.updateSperreSetzenErlaubt = false;
              } else {
                this.updateSperreSetzenErlaubt = true;
              }
            }
          }
        },
        methods: {
            load() {
                axios.get(Scoop.baseUrl + '/categories').then(response => {
                    this.allCategories = response.data.categories;
                });
            },
            updateMany() {
                this.massupdateLoading = true;

                if (this.massupdate.category) {
                    this.massupdate.category = this.massupdate.category.value;
                }

                axios.post(this.route, {
                    data: {
                        massupdate: this.massupdate,
                        selectedRows: this.selectedRows,
                        replaceCategories: this.replaceCategories,
                        selectedTreeCategory: this.selectedTreeCategory,
                    }
                }).then(() => {
                    window.location.reload();
                });
            },
            onStartChange: function (selectedDates, dateStr) {
              this.$set(this.flatpickr.end, 'minDate', dateStr);
              this.$set(this.flatpickr.vt, 'maxDate', dateStr);
            },

            onEndChange: function (selectedDates, dateStr) {
              this.$set(this.flatpickr.start, 'maxDate', dateStr);
            },
        },
      mounted() {
        axios.get(Scoop.baseUrl + '/selects/clientList').then((response) => {
          this.clientList = response.data;
        });
      },
    }
</script>

<template>
    <Lightbox
            id="massupdate"
            headline="Massenupdate"
            :subheadline="total + ' Artikel im Filter, ' + (selectedRows.length ? selectedRows.length : 'alle') + ' Artikel selektiert'"
            @lightboxopening="widgetOpen = true"
            @lightboxclosing="widgetOpen = false"
    >
        <span slot="open-template">
            <button class="btn btn-default btn-sm m-t-md pull-left">
                <i class="fa fa-tags"></i>
                <span>Massenupdate</span>
            </button>
        </span>
        <div slot="body">
            <div class="row" v-if="massupdateLoading">
                <div class="col-md-12 text-center">
                    <i class="fa fa-refresh fa-spin fa-2x text-muted"></i>
                    <h4>Update wird durchgeführt</h4>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12">
                    <div class="col-md-4">
                        <strong style="line-height: 35px">Kategorie</strong>
                    </div>
                    <div class="col-md-8 pull-right">
                        <template v-if="allCategories">
                            <div class="select">
                                <v-select
                                        v-model="massupdate.category"
                                        :options="allCategories"
                                        class="white-bg"
                                ></v-select>
                            </div>
                        </template>
                        <template v-else>
                            Loading categories <i class="fa fa-spinner fa-spin"></i>
                        </template>
                    </div>
                    <div class="col-md-8 pull-right">
                        <div class="radio">
                            <label>
                                <input type="radio" value="add" v-model="massupdate.replaceCategories">
                                Kategorien hinzufügen
                            </label>
                        </div>
                        <div class="radio">
                            <label>
                                <input type="radio" value="replace" v-model="massupdate.replaceCategories">
                                Kategorien ersetzen
                            </label>
                        </div>
                        <div class="radio">
                            <label>
                                <input type="radio" value="remove" v-model="massupdate.replaceCategories">
                                Kategorien entfernen
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <div class="col-md-4">
                        <strong style="line-height: 65px">Updatesperre</strong>
                    </div>
                    <div class="col-md-8 pull-right">
                        <div class="radio">
                            <label><input type="radio" v-model="massupdate.autosort_lock"
                                          :value="1"  :disabled="!updateSperreSetzenErlaubt">
                              <template v-if="!updateSperreSetzenErlaubt">
                                <strong>Ja</strong>
                                  <br><small>(Wird immer gesetzt, wenn Kategorien geändert werden.)</small>
                              </template>
                              <template v-else>
                                Ja
                              </template>
                            </label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="massupdate.autosort_lock"
                                          :value="0" :disabled="!updateSperreSetzenErlaubt">Nein</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <div class="col-md-4">
                        <strong style="line-height: 65px">Blacklist</strong>
                    </div>
                    <div class="col-md-8 pull-right">
                        <div class="radio">
                            <label><input type="radio" v-model="massupdate.blacklist"
                                          :value="1">Hinzufügen</label>
                        </div>
                        <div class="radio">
                            <label><input type="radio" v-model="massupdate.blacklist"
                                          :value="0">Entfernen</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <hr>
                    <div class="col-md-4">
                        <strong style="line-height: 35px">Stilrichtung (Attribut)</strong>
                    </div>
                    <div class="col-md-8 pull-right">
                        <div class="select">
                            <v-select v-model="massupdate.styleAttribute.select"
                                      :options="attributeValues"
                                      class="white-bg"
                            ></v-select>
                        </div>
                    </div>
                    <div class="col-md-8 pull-right">
                        <div class="radio">
                            <label>
                                <input type="radio" value="add" v-model="massupdate.styleAttribute.action">
                                hinzufügen
                            </label>
                        </div>
                        <div class="radio">
                            <label>
                                <input type="radio" value="remove" v-model="massupdate.styleAttribute.action">
                                entfernen
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                  <hr>
                  <div class="col-md-4">
                    <strong style="line-height: 65px">Online ab</strong>
                  </div>
                  <div class="col-md-8 pull-right">
                    <flat-pickr class="form-control"
                                :config="flatpickr.start"
                                v-model="massupdate.onlineSince.date"
                                @on-change="onStartChange">
                    </flat-pickr>
                    <div>
                      <v-select
                          multiple
                          v-if="clientList && clientList.length > 0"
                          :options="clientList"
                          v-model="massupdate.onlineSince.clients"
                          :reduce="client => client.id"
                      ></v-select>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio" value="add" v-model="massupdate.onlineSince.action">
                        hinzufügen
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio" value="remove" v-model="massupdate.onlineSince.action">
                        entfernen
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr>
                  <div class="col-md-4">
                    <strong style="line-height: 65px">Neu ab</strong>
                  </div>
                  <div class="col-md-8 pull-right">
                    <flat-pickr class="form-control"
                                :config="flatpickr.start"
                                v-model="massupdate.newSince.date"
                                @on-change="onStartChange">
                    </flat-pickr>
                    <div>
                      <v-select
                          multiple
                          v-if="clientList && clientList.length > 0"
                          :options="clientList"
                          v-model="massupdate.newSince.clients"
                          :reduce="client => client.id"
                      ></v-select>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio" value="add" v-model="massupdate.newSince.action">
                        hinzufügen
                      </label>
                    </div>
                    <div class="radio">
                      <label>
                        <input type="radio" value="remove" v-model="massupdate.newSince.action">
                        entfernen
                      </label>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div v-cloak slot="footer" v-show="!massupdateLoading">
            <button
                    :class="['btn btn-default btn-sm pull-left', Object.keys(this.massupdate).length == 0 ? 'disabled' : '']"
                    @click="massupdate = {}">
                <i class="fa fa-undo"></i>
            </button>
            <button
                    :class="['btn btn-primary btn-sm', Object.keys(this.massupdate).length == 0 ? 'disabled' : '']"
                    @click="updateMany">Massenupdate durchführen
            </button>
        </div>
    </Lightbox>
</template>
